
import { Testimonial } from "@/components/index/testimonials/types";

// Mock testimonials data
export const mockTestimonials: Testimonial[] = [
  {
    id: "1",
    name: "Sarah Johnson",
    role: "Party Host",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    content: "MysteryAct has completely transformed our get-togethers! Our friends now eagerly anticipate our monthly mystery nights. The Victorian-era script was so immersive that everyone stayed in character the entire evening.",
    rating: 5,
    location: "New York, USA"
  },
  {
    id: "2",
    name: "Michael Zhang",
    role: "Board Game Enthusiast",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    content: "As someone who's played countless board games, I was skeptical about MysteryAct. But the depth of storytelling and character development blew me away. It's like being inside a murder mystery novel!",
    rating: 5,
    location: "Beijing, China"
  },
  {
    id: "3",
    name: "Elena Rodriguez",
    role: "Drama Teacher",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop",
    content: "I've used MysteryAct scripts for my high school drama class, and the students absolutely love them. The scripts are well-written, engaging, and provide an excellent introduction to improvisation.",
    rating: 4,
    location: "Madrid, Spain"
  },
  {
    id: "4",
    name: "James Wilson",
    role: "Corporate Event Planner",
    avatar: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=150&h=150&fit=crop",
    content: "Our team-building event using MysteryAct was the highlight of our company retreat. It encouraged collaboration, creative thinking, and brought people from different departments together.",
    rating: 5,
    location: "Toronto, Canada"
  },
  {
    id: "5",
    name: "Olivia Thompson",
    role: "Mystery Novel Fan",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop",
    content: "The attention to detail in the historical MysteryAct scripts is impressive. As a mystery novel enthusiast, I appreciate how they balance accessibility for newcomers with satisfying twists for experienced sleuths.",
    rating: 4,
    location: "London, UK"
  }
];
